import React, { ReactNode } from 'react';
import { Flex } from 'antd';

const styles = {
  filterBody: {
    marginBottom: '2rem',
  },
};

type Props = {
  children?: ReactNode;
};

const FiltersBody = ({ children }: Props) => {
  return (
    <Flex justify={'flex-start'} align={'center'} style={styles.filterBody}>
      {children}
    </Flex>
  );
};

export default FiltersBody;
